{
  "main": {
    "title": "Registro del pilota",
    "nazaj": "Indietro"
  },
  "navs": {
    "vnos": "Inserimento",
    "dnevnik": "Registro"
  },
  "labels": {
    "datum": "Data:",
    "casO": "Ora di partenza:",
    "krajV": "Luogo di decollo: LJAJ",
    "casP": "Ora di arrivo:",
    "krajP": "Luogo di atterraggio: LJAJ",
    "model": "Modello, variante",
    "reg": "Registrazione aeromobile: S5-XYZ",
    "ime": "Nome del comandante",
    "posadka": "Equipaggio singolo / multiplo:",
    "posadkaVec": "MULTI",
    "skupniCas": "Tempo totale di volo:",
    "stPristankovDN": "Numero di atterraggi (Giorno / Notte):",
    "dan": "Giorno",
    "noc": "Notte",
    "stPristankov": "Numero di atterraggi:",
    "op": "Condizioni operative:",
    "opD": "Diurno",
    "opN": "Notturno",
    "vlogaP": "Ruolo del pilota:",
    "fstd": "Tempo totale su FSTD:",
    "opomba": "Nota"
  },
  "buttons": {
    "vnesiZapis": "Inserisci registrazione"
  },
  "obvestila": {
    "zapisDodan": "Record aggiunto con successo.",
    "napakaVnosa": "Errore nell'inserimento dei dati.",
    "napakaInputa": "Per aggiungere un record è necessario compilare tutti i dati. Verifica di aver compilato tutti i campi!",
    "napakaBranja": "Errore nella lettura dei dati."
  }
}